module.exports = __webpack_public_path__ + "img/invoiceExportAct.44b9917f.png";